import React from "react";

export default function Title(props) {
  return (
    <div className="pb-8">
      <h1 className="font-semibold text-2xl">{props.title}</h1>
      <p className="text-xs">{props.caption}</p>
    </div>
  );
}
